





















import {
  Vue,
  Component
} from 'vue-property-decorator'
// import axios from 'axios'
// import states from '@/assets/dictionaries/state-list.ts';
declare module '@/assets/dictionaries/state-list.ts';

@Component
export default class AdminHub extends Vue {

}
